__webpack_require__.p = "/colunga/viz-colunga/mortalidad-infantil/menu/";